<button class="text-gray-900 p-3 rounded-lg text-sm font-medium"
        [ngClass]="[this.disabled ?'bg-[#D9D9D9]': bgStyle, class]"
        [disabled]="this.disabled">
  <ng-content></ng-content>
</button>
